var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndex = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "2.75 2.75 12.5 12.5",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 7H5.5V11H8.5V7Z M12.5 8H10V9H12.5V8Z M10 10H12.5V11H10V10Z M15.25 4.5C15.25 4.08579 14.9142 3.75 14.5 3.75H3.5C3.08579 3.75 2.75 4.08579 2.75 4.5V13.5C2.75 13.9142 3.08579 14.25 3.5 14.25H14.5C14.9142 14.25 15.25 13.9142 15.25 13.5V4.5ZM4.25 5.25L13.75 5.25V12.75H4.25L4.25 5.25Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndex);
export default ForwardRef;